(function () {
    'use strict';

    angular
        .module('core.constants', [])
        .constant('LOCAL_STORAGE_ITEMS', {
            ACCESS_TOKEN: 'LavpopSSOAccessToken',
            ACCESS_TOKEN_REFRESH: 'LavpopSSORefreshAccessToken',
            ACCESS_TOKEN_EXPIRATION: 'LavpopSSOAccessTokenExpiration',
            ACCESS_TOKEN_OWNER: 'LavpopSSOAccessTokenOwner',
            MENU: 'LavpopSSOMenu',
            SELECTED_UNIT: 'SelectedUnitId',
            APPLICATION_AUTH: 'LavpopSSOApplicationAuth',
            APPLICATION_AUTH_EXPIRATION: 'LavpopSSOApplicationAuthExpiration',
            CUSTOM_FILTERS: 'LavpopSSOCustomFilters'
        })
        .constant('AUTH_EVENTS', {
            NOT_AUTHENTICATED: 'auth-not-authenticated'
        })
        .constant('DATA_EVENTS', {
            SELECTED_UNIT_CHANGE: 'selected-unit-change'
        })
        .constant('PATHS', {
            PHYSICAL: '/app/src/angular/core'
        })
        .constant('ROUTES', {
            APP: '__SITE_URL__',
            API: '__API_URL__',
            SSO: '__SSO_URL__'
        })
        .constant('APPLICATION_URLS', {
            CENTRAL_PURCHASES: '__CENTRAL_PURCHASES_URL__'
        })
        .constant('DEFAULT_IDENTIFIERS', {
            ACCESS_LEVEL_FRANCHISER_ADMINISTRATOR: 1,
            ACCESS_LEVEL_FRANCHISER_WORKER: 2,
            ACCESS_LEVEL_FRANCHISEE: 3,
            ACCESS_LEVEL_FRANCHISEE_WORKER: 4
        })
        .constant('SYSTEM_MODULES', {
            FRANCHISEE_APPLICATION: 2,
            FRANCHISEE_UNIT: 3,
            FRANCHISEE_PEOPLE: 4,
            FRANCHISER_APPLICATION: 5,
            FRANCHISER_UNIT: 6,
            FRANCHISER_PEOPLE: 7,
            FRANCHISER_ECONOMIC_GROUP: 8,
            FRANCHISER_CLUSTER: 9,
            FRANCHISER_ACCESS_LEVEL: 10,
            FRANCHISER_RESPONSABILITY: 11,
            FRANCHISER_PAYMENT_SLIP: 12,
            FRANCHISER_CLUSTER_PERFORMANCE: 18
        });
}());
